import React, { createContext, useEffect, useRef, useState } from 'react'
import { getFluidProps, isBrowser, partInViewport } from '../lib/helpers'
import PortableText from './portableText'
import classNames from 'classnames'
import { Link } from 'gatsby'
import InfoI from '../images/icons/info-i.svg'
import AudioPlayer from './audio-player'
import Img from 'gatsby-image'

export const AudioContext = createContext()

function AudioContextWrapper({ src, children }) {
  const [duration, setDuration] = useState(0)
  const [currentTime, _setCurrentTime] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const timerIntervalRef = useRef()
  const audioRef = useRef()

  function setCurrentTime(value) {
    const nextValue = duration * value / 100
    _setCurrentTime(nextValue)
    audioRef.current.currentTime = nextValue
  }

  function handleOnEnded(e) {
    setIsPlaying(false)
    clearInterval(timerIntervalRef.current)
  }

  function handleOnLoadedMetadata(e) {
    setDuration(e.target.duration)
    _setCurrentTime(e.target.currentTime)
  }

  function handleOnClick() {
    const value = !isPlaying
    setIsPlaying(value)
    if (value) {
      audioRef.current.play()
      if (audioRef.current.currentTime === 0 && currentTime !== 0) {
        _setCurrentTime(0)
      }
      audioRef.current.play()
      timerIntervalRef.current = setInterval(() => {
        _setCurrentTime((value) => (value + 0.1))
      }, 100)
    }
    else {
      audioRef.current.pause()
      clearInterval(timerIntervalRef.current)
      _setCurrentTime(audioRef.current.currentTime)
    }
  }


  // useEffect(() => {
  //   clearInterval(timerIntervalRef.current)
  // }, [])

  useEffect(() => {
    if (src) {
      audioRef.current = new Audio(src)
      audioRef.current.addEventListener("loadedmetadata", handleOnLoadedMetadata)
      audioRef.current.addEventListener("ended", handleOnEnded)
    }
  }, [src])



  return <AudioContext.Provider value={{ duration, currentTime, setCurrentTime, isPlaying, setIsPlaying, handleOnClick }}>
    {children}
  </AudioContext.Provider>
}

class Conversation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isBodySliderRendereded: false,
      isHeaderSliderVisible: true,
      isOverlaySliderOpen: false,
      isOverlaySliderVisible: true,
      slideIndex: 0,
      isPlaying: false
    }
    this.modalRef = React.createRef()
    this.pageContainerRef = React.createRef()
    this.toggleOverlaySlider = this.toggleOverlaySlider.bind(this)
  }

  onScroll = () => {
    const el = document.getElementById('gallery-slider-header')
    if (el) {
      this.setState({
        isHeaderSliderVisible: partInViewport(el, 0, 136),
      })
    }
  }

  toggleBodySlider = isVisible => {
    this.setState({
      isHeaderSliderVisible: isVisible,
    })
  }

  setSlideIndex = i => {
    this.setState({
      slideIndex: i,
    })
  }

  toggleOverlaySlider = () => {
    const { isOverlaySliderOpen, isOverlaySliderVisible } = this.state
    // toggle slider open
    this.setState({
      isOverlaySliderOpen: !isOverlaySliderOpen,
    })
    if (isOverlaySliderVisible) {
      document.body.classList.add('overlay-slider-transition-delay')
      setTimeout(() => {
        document.body.classList.remove('overlay-slider-transition-delay')
      }, 400)
    }
  }

  renderButtonLinks(link) {
    const _link = link.article ? link.article : link
    if (_link.artistReference) {
      const slug = _link.artistReference.slug && _link.artistReference.slug.current
      if (slug)
        return (
          <Link className="btn" to={`/artists/${slug}`}>
            {_link.title ? _link.title : 'Bio'}
          </Link>
        )
    } else {
      return (
        <a
          className="btn"
          href={_link.download ? _link.download.asset.url : _link.externalLink}
          target="_blank"
          rel="noopener noreferrer"
          key={link._key}
        >
          {_link.title}
        </a>
      )
    }
  }

  render() {
    const {
      artist,
      title,
      tags,
      audio,
      artistListTitle,
      artistList,
      showArtistList,
      collaboratorListTitle,
      collaboratorList,
      showCollaboratorList,
      mainImage,
      relatedConversationsTitle,
      relatedConversations,
      _rawFormattedTitle,
      _rawPressLinks,
      _rawBioLinks,
      _rawBody,
      _rawArtistGroup,
    } = this.props
    const classes = classNames({
      'is-body-slider-rendered': this.state.isBodySliderRendereded,
      'is-body-slider-visible': !this.state.isHeaderSliderVisible,
      'has-artist-group': _rawArtistGroup,
    })
    const hasArticles = _rawPressLinks && _rawPressLinks.length

    return (
      <AudioContextWrapper src={audio?.asset?.url}>
        <div className="page-container" ref={this.pageContainerRef}>
          <div className={`collaboration ${classes}`}>
            <div className="collaboration__header">
              <h1 className="collaboration__title">
                {title && artist && (
                  <>
                    <span className="collaboration-title__name">
                      <em>
                        {_rawFormattedTitle ? (
                          <PortableText blocks={_rawFormattedTitle} />
                        ) : (
                          <>{title}</>
                        )}
                      </em>
                      {artist}
                      <br />
                    </span>
                  </>
                )}
              </h1>
              <div className="conversation__chips">
                <div>
                  {tags &&
                    tags.map(tag => (
                      <div className="btn content-tag content-tag--info" key={tag._id}>
                        {tag.title}
                      </div>
                    ))}
                </div>
                {/* {_rawPressLinks && _rawPressLinks.length ? (
                    // seems like a nonsense? pressLinks is array but links to ./press??
                    <Link className="btn" to="press">
                      Press
                    </Link>
                  ) : (
                    <></>
                  )} */}
              </div>
            </div>
            {/* body */}
            <div className="collaboration__body">
                <div className="collaboration__album-wrapper">
                  <div className="collaboration__album">
                    {mainImage && <div className='collaboration__album__cover'><Img fluid={getFluidProps(mainImage, 1200)} /></div>}
                    {audio && <AudioPlayer></AudioPlayer>}
                    {_rawBioLinks && <div className='collaboration__album__links'>{_rawBioLinks.map(link => this.renderButtonLinks(link))}</div>}
                  </div>
                </div>
              <div className="collaboration__body-inner">
                {_rawBody && <PortableText blocks={_rawBody} />}
              </div>
            </div>
            {/* artist list */}
            {artistList && showArtistList && (
                <div className="collaboration__artist-list">
                  <div className="btn btn--info">
                    {artistListTitle ? artistListTitle : 'Participant Artists'}
                  </div>
                  <ul>
                    {artistList.map((artist, i) => {
                      if (artist.slug)
                        return (
                          <li key={i}>
                            <Link to={`/artists/${artist.slug.current}`}>
                              <div className="btn icon-btn">
                                <InfoI />
                              </div>
                              <div>{artist.title}</div>
                            </Link>
                          </li>
                        )
                    })}
                  </ul>
                </div>
            )}
            {
              collaboratorList && showCollaboratorList && (
                <div className="collaboration__artist-list">
                  <div className="btn btn--info">
                    {collaboratorListTitle ? collaboratorListTitle : 'Participant Collaborators'}
                  </div>
                  <ul>
                    {collaboratorList.map((collaborator, i) => {
                      if (collaborator.slug)
                        return (
                          <li key={i}>
                            <Link to={`/collaborators/${collaborator.slug.current}`}>
                              <div className="btn icon-btn">
                                <InfoI />
                              </div>
                              <div>{collaborator.title}</div>
                            </Link>
                          </li>
                        )
                    })}
                  </ul>
                </div>
              )
            }
            {/* related collaborations */}
            {relatedConversations && relatedConversations.length ? (
              <>
                <div className="collaboration__related-list">
                  <div className="btn btn--info">
                    {relatedConversationsTitle
                      ? relatedConversationsTitle
                      : 'Featured Conversations'}
                  </div>
                  {relatedConversations.map((node, i) => {
                    const { title, location, slug, _rawFormattedTitle } = node
                    return (
                      <li key={node.id}>
                        <Link to={`/collaborations/${slug.current}`}>
                          {_rawFormattedTitle ? (
                            <em>
                              <PortableText blocks={_rawFormattedTitle} />
                            </em>
                          ) : (
                            <>{title && <em>{title}</em>}</>
                          )}
                        </Link>
                      </li>
                    )
                  })}
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </AudioContextWrapper>
    )
  }
  componentDidMount() {
    if (!isBrowser()) {
      return
    }
    document.addEventListener('scroll', this.onScroll)
    // this.onScroll()
    this.forceUpdate()
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.onScroll)
  }
}

export default Conversation
